import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import tooltipcss from "../css/tooltip.module.css";

export const Tooltip = ({
  children,
  content,
  position = "top",
  variant = "green",
  enable = true,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={tooltipcss.wrapper}
      onMouseEnter={() => {
        enable ? setVisible(true) : setVisible(false);
      }}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          className={`${tooltipcss.tooltip} ${tooltipcss[position]} ${tooltipcss[variant]}`}
        >
          {content}
          <span
            className={`${tooltipcss.arrow} ${
              tooltipcss[`arrow-${position}`]
            } ${tooltipcss[`${variant}-arrow`]}`}
          />
        </div>
      )}
    </div>
  );
};

export const Tooltip2 = ({
  children,
  content,
  position = "top",
  variant = "green",
  enable = true,
}) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (visible && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      let top = rect.top + window.scrollY;
      let left = rect.left + window.scrollX;

      if (position === "right_2") {
        left += rect.width + 5;
        top += rect.height / 2;
        setCoords({ top, left });
      } else if (position === "top") {
        top -= 8;
        left += rect.width / 2;
        setCoords({ top, left });
      }
    }
  }, [visible, position]);

  const show = () => {
    clearTimeout(timeoutRef.current);
    setVisible(true);
  };

  const hide = () => {
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
    }, 100); // small delay to allow hover to transfer to tooltip
  };

  return (
    <>
      <div
        ref={wrapperRef}
        className={tooltipcss.wrapper}
        onMouseEnter={show}
        onMouseLeave={hide}
      >
        {children}
      </div>

      {visible &&
        ReactDOM.createPortal(
          <div
            className={`${tooltipcss.tooltip} ${tooltipcss[position]} ${tooltipcss[variant]}`}
            onMouseEnter={show}
            onMouseLeave={hide}
            style={{
              top: coords.top,
              left: coords.left,
              position: "absolute",
              zIndex: 9999,
            }}
          >
            {content}
          </div>,
          document.body
        )}
    </>
  );
};
